export const extractInvitationCodeFromUrl = (suppliedUrl) => {
  const url = new URL(suppliedUrl);

  const { searchParams } = url;
  const invitationCode = searchParams.get('invitation');

  return invitationCode;
};
